import React, { useState, useMemo } from "react";
import GalleryCard from "../Components/Gallery/GalleyCard";
import GalleryModal from "../Components/Gallery/GalleryModal";
import Background from "./../assets/resources/Lobby_view1.jpg";
import "./building_page.css";
import SEO from "../Components/SEO/SEO";

export default function Gallery() {
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Generate gallery data from local images (1-8) and video
  const galleryData = useMemo(() => {
    const images = Array.from({ length: 8 }, (_, index) => {
      const imageNumber = index + 1;
      return {
        id: imageNumber,
        public_url: `/img/resources/gallery/${imageNumber}.webp`,
        type: "image/webp",
      };
    });

    // Add video at the end
    images.push({
      id: 9,
      public_url: "/img/resources/union_video.MOV",
      type: "video/quicktime",
    });

    return images;
  }, []);

  const handleMediaClick = (media) => {
    setSelectedMedia(media);
    setIsModalOpen(true);
  };

  return (
    <>
      <SEO
        title="Gallery | Union Center Flushing Office Building"
        description="Explore Union Center's photo gallery showcasing our modern office spaces, luxurious lobby, state-of-the-art facilities, and architectural design in Flushing, Queens."
        keywords="Union Center gallery, Flushing office photos, commercial real estate gallery, modern office building, office space photos, Flushing commercial building"
        canonical="https://www.3716union.com/gallery"
        ogTitle="Gallery | Union Center Flushing Office Building"
        ogDescription="Explore Union Center's photo gallery showcasing our modern office spaces, luxurious lobby, and state-of-the-art facilities."
        ogImage="https://www.3716union.com/img/resources/Lobby_view1.jpg"
        ogUrl="https://www.3716union.com/gallery"
      />
      <div className="flex flex-col w-full mb-20 bg-white">
        <div className="relative">
          <img
            className="object-cover w-full h-screen"
            src={Background}
            alt="Background"
            fetchPriority="high"
            loading="eager"
          />
          <div className="absolute inset-0 bg-[#7e6140] opacity-30"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-white text-center text-5xl md:text-6xl font-normal">
              Gallery
            </h1>
          </div>
        </div>

        <div className="w-full px-4 py-16 bg-white">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-10 max-w-[1200px] mx-auto">
            {galleryData.map((item) => (
              <GalleryCard
                key={item.id}
                img={item.public_url}
                type={item.type}
                onClick={() => handleMediaClick(item)}
              />
            ))}
          </div>
        </div>

        <GalleryModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          media={selectedMedia?.public_url}
          type={selectedMedia?.type}
        />
      </div>
    </>
  );
}
